import { IPropertyEditable } from "../../../../base/domain/system/edit";
import { IQuestionnaire, QuestionnaireType } from "../../../../documaker/domain/format/objects";
import { IFormatObjectEditable } from "../IFormatObjectEditable";
import { IFormatSpecification } from "../IFormatSpecification";
import { ITextObject } from "../objects";
import { IQuestionnairePropertyEditable } from "../properties";
import { TextObjectEditor } from "./TextObjectEditor";

export class QuestionnaireTextObjectEditor extends TextObjectEditor implements IQuestionnairePropertyEditable {
  constructor(source: ITextObject | QuestionnaireTextObjectEditor, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
    this._questionnaire = this.createPropertyEditor(s => s.questionnaire, (s, v) => s.questionnaire = v);
  }

  protected _questionnaire: IPropertyEditable<IQuestionnaire>;

  questionnaire(): IPropertyEditable<IQuestionnaire> {
    return this._questionnaire;
  }

  selectableQuestionnaireTypes(): (QuestionnaireType | undefined)[] {
    const questionnaire = this._questionnaire.getValue();
    switch (questionnaire.type) {
      case "string":
      case "text":
        return ["string", "text"];
      case "display":
        return ["display"];
      case "group":
        return ["group"];
      case "decimal":
      case "integer":
        return ["integer", "decimal"];
      default:
        return [];
    }
  }

  getTypeName(): string {
    const questionnaire = this._questionnaire.getValue();
    switch (questionnaire.type) {
      case "text":
      case "string":
        return "フリー入力";
      case "display":
        return "固定テキスト";
      case "group":
        return "グループ";
      case "decimal":
      case "integer":
        return "数値";
      default:
        return "";
    }
  }

  clone(): IFormatObjectEditable {
    return new QuestionnaireTextObjectEditor(this);
  }
}
